import { useUserNetworksQuery } from '@/services/userApiQueries';
import { useAuth } from '@acast-tech/auth-client';
import { usePageMetadata } from '@/hooks';

const useNetworks = () => {
  const auth = useAuth();
  const { app } = usePageMetadata();
  const { userId, isImpersonating } = auth;
  const { data: networks, isPending, error } = useUserNetworksQuery(userId, isImpersonating);
  const networkList = networks?.[app];

  return { data: networkList, isPending, error };
};

export default useNetworks;
